$(document).ready(function () {
  // Accordion toggle functionality
  $('.js-toggleBttn').addClass('js-toggleBtn');
  $('.js-toggleBody').hide();

  const buttons = $('.js-toggleBtn');
  

  buttons.on('click', function (e) {
    e.preventDefault();
    $(this).closest('.toggle__item').find('.js-toggleBody').slideToggle(300);
    $(this).toggleClass('is-active');
  });
});
